import styled from "@emotion/styled";

export const Categories = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
